// NEW IMPLEMENTATION
function isSubset(subset, array) {
  const set = new Set(array);
  return subset.every(item => set.has(item));
}

function attemptImageChange() {
    const imageList = document.querySelectorAll('.product product-gallery page-dots img[alt]');
    for (const image of imageList) {
        let altTextComponents = image.alt.split('|').map((element) => element.trim().toLowerCase()); 
        if(isSubset(altTextComponents, Object.values(window.scpoSelectedOptions).filter(e => e != undefined))) {
            image.parentElement.click();
            return;
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_changed', (e) => {
        const optionKey = e.data.option_key;
        const optionValue = Array.isArray(e.data.value) ? e.data.value[0] : e.data.value;
        if (!window.scpoSelectedOptions) {
            window.scpoSelectedOptions = {};
        }
        window.scpoSelectedOptions[optionKey] = optionValue?.trim().toLowerCase();
        attemptImageChange();
    })
})
